import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, image, canonical, schemaMarkup }) {
  const siteName = 'Entreprenør Jan Hedegaard ApS';
  const fullTitle = title 
    ? (title.includes('Jan Hedegaard') || title.includes('|') ? title : `${title} | ${siteName}`) 
    : siteName;
  const defaultDescription = 'Professionel kloakmester i Galten og omegn. Vi udfører alt inden for kloakarbejde, kloakseparering, spildevand og TV-inspektion for erhverv og private.';

  const defaultImage = 'https://assets.auxodev.dk/assets/6015610c-faa3-4021-bc7e-a866f30ca512/43586154-92d6-43c8-8757-0c72ffc22dd7.jpg';
  const ogImageUrl = image || defaultImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={ogImageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={ogImageUrl} />
      <meta property="og:type" content="website" />
      {canonical && <link rel="canonical" href={canonical} />}
      <html lang="da" />
      {schemaMarkup && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(schemaMarkup) ? { "@context": "https://schema.org", "@graph": schemaMarkup } : schemaMarkup)}
        </script>
      )}
    </Helmet>
  );
}
